/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamPatchRequestSchema = z.object({
  description: z.string().nullish(),
  loopId: z.int().nullish(),
  name: z.string().nullish(),
});
